import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/24/solid";

export default function ServiceListBox({
    services,
    form,
    setForm,
    onChangeService,
    isError = false,
    disabled = false,
}) {
    const filteredServices = form.search
        ? services.filter((service) =>
              service.name.toLowerCase().includes(form.search.toLowerCase())
          )
        : services;

    const selectedService = services.find((s) => s.id === form.service_id);

    return (
        <div className="mt-2 sm:mt-6">
            <label
                htmlFor="service"
                className="block text-sm font-medium text-left text-gray-700"
            >
                Service <span className="text-red-500">*</span>
            </label>
            <Listbox
                by="id"
                as="div"
                className="relative inline-block w-full text-left"
                value={selectedService}
                onChange={onChangeService}
                disabled={disabled}
            >
                <div>
                    <Listbox.Button
                        className={`inline-flex justify-between w-full px-3 py-2 text-sm font-normal text-gray-700 truncate bg-white rounded-md shadow-sm focus:outline-none focus:ring-0 ${
                            disabled
                                ? "cursor-not-allowed bg-gray-100 text-gray-400"
                                : "hover:bg-gray-50"
                        } ${
                            isError
                                ? "border border-red-500"
                                : "border border-gray-200"
                        }`}
                        disabled={disabled}
                    >
                        <span>{selectedService?.name || "Select Service"}</span>
                        <ChevronUpDownIcon className="w-5 h-5" aria-hidden="true" />
                    </Listbox.Button>
                </div>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Listbox.Options className="right-0 z-10 w-full mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <ul className="w-full py-1 overflow-auto max-h-72">
                            {filteredServices.map((service) => (
                                <Listbox.Option
                                    key={service.id}
                                    value={service}
                                    className="m-5 cursor-pointer"
                                >
                                    {({ active, selected }) => (
                                        <div
                                            className={`${
                                                active
                                                    ? "text-white bg-blue-600"
                                                    : "text-gray-900"
                                            } cursor-pointer select-none relative pl-8 pr-4`}
                                        >
                                            {selected && (
                                                <span
                                                    className={`${
                                                        active
                                                            ? "text-white"
                                                            : "text-blue-600"
                                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                                >
                                                    <CheckIcon className="w-5 h-5 text-green-600" />
                                                </span>
                                            )}
                                            <span
                                                className={`${
                                                    selected
                                                        ? "font-semibold"
                                                        : "font-normal"
                                                } block truncate`}
                                            >
                                                {service.name}
                                            </span>
                                        </div>
                                    )}
                                </Listbox.Option>
                            ))}
                        </ul>
                    </Listbox.Options>
                </Transition>
            </Listbox>
        </div>
    );
}
